import * as React from "react";
import { colors } from "./styles";
export const Transitions = React.memo(({ transitions, currentState, }) => {
    return (React.createElement("ul", { style: { listStyleType: "none", padding: "0", fontSize: "14px" } }, Object.keys(transitions).map((state) => {
        return (React.createElement("li", { key: state },
            React.createElement("div", { style: {
                    color: state === currentState ? colors.orange : colors.text,
                } }, state),
            React.createElement("ul", { style: {
                    listStyleType: "none",
                    padding: "0.25rem 0.5rem",
                } }, Object.keys(transitions[state]).map((event) => {
                return (React.createElement("li", { key: event, style: { color: colors.green, fontSize: "14px" } }, event));
            }))));
    })));
});
//# sourceMappingURL=Transitions.js.map